import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewEncapsulation } from "@angular/core";
import * as moment from "moment";
import * as dayJs from "dayjs";
import * as stringsData from "../stringFiles/pendingFeesReport.json";
import { firstValueFrom } from "rxjs";
import { PendingFeesReportService } from "./pending-fees-report.service";
import { AttendanceService } from "../attendance-report/attendance-report.service";
import { CategoryService } from "../category-wise-report/category-wise-report.services";
import { BroadcastService } from "../broadcast/broadcast-service.service";
import { ToWords } from 'to-words';
import CurrencyList from 'currency-list'
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var customToastr: any;
@Component({
    selector: "app-pending-fees-report",
    providers: [AttendanceService, CategoryService, BroadcastService, PendingFeesReportService],
    templateUrl: "./pending-fees-report.component.html",
    styleUrls: [
        "./pending-fees-report.component.css",
        "./../../assets/css/theme-default/materialadmin.css",
        "./../../assets/css/theme-default/font-awesome.min.css",
        "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
        "./../../assets/css/theme-default/material-design-iconic-font.min.css",
        "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
        "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
        "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
        "./../../_crop/css/style.css",
        "./../../_crop/css/style-example.css",
    ],
    encapsulation: ViewEncapsulation.None,
})
export class PendingFeesReportComponent implements OnInit {
    currencyType = localStorage.getItem('currency')
    currencyName = CurrencyList.get(this.currencyType)
    toWords = new ToWords({converterOptions :{
        currency: true,
        currencyOptions : {
            name: this.currencyName.name,
      plural: this.currencyName.name_plural,
      symbol: this.currencyName.symbol,
      fractionalUnit: {
        name: this.currencyName.name,
        plural: this.currencyName.name_plural,
        symbol: this.currencyName.symbol,
      },
        }
    }});
    private langChangeSubscription: any;
    isFilterExpanded: boolean = false;
    isOpenStudentSelection: boolean = false;
    isOptionOpened: boolean = false;
    optionHeaderIndex: string = "";
    allStudentSelected: boolean = false;
    selectedWing: any = null;
    selectedSection: any = null;
    selectedClass: any = null;
    wingListData: any = [];
    classStandardData: any = [];
    classSectionData: any = [];
    genderData: any = [];
    selectedGender: any = null;
    studentList: any = [];
    selectedStudentListLength: any = "";
    resultLength: string = "0";
    studentStatData: any = [];
    pendingFeeData: any = [];
    startingPageNumber: any = 1;
    pageNumbers: any = [];
    maxPageNumber: any = "";
    pageLimit: any = "";
    tableHeaderData: any = [];
    tableBodyData: any = [];
    pageLimitForClassWiseDate: any = "10";
    resultAvailable: any = "";
    appliedWing: any = "All";
    appliedClass: any = "All";
    appliedSection: any = "All";
    appliedGender: any = "All";
    appliedStudent: any = "";
    string: any;
    loadingStatData: boolean = true;
    loadingClassTileData: boolean = true;
    loadingClassTableData: boolean = false;
    loadingWingData: boolean = true;
    loadingClassData: boolean = false;
    loadingSectionData: boolean = false;
    loadingStudentDropdownData: boolean = false;
    enableReset: boolean = false;
    enableBackButton: boolean = false;
    selectedYearId: number | null = null;
    academicYears: Array<any> = [];
    searchStudentData = [];
    schoolCurrencySymbol: string;
    selectAllChecked = false;
    completeStudentList = [];
    isExportingReport = false;
    isFocused: boolean = false;
    filterWingId: any='All';
    filterClassId:any='All';
    filterSectionId:any='All';
    filterGender:any='All';
    filterSelectedStudent:any='All';
    isSelectedStudentCountDisplay = true;

    appliedWings : any = "All";
    appliedClassStandard : any = "All";
    appliedClassId : any = "All"; 
    appliedGenders : any = 'All';
    selectedStudent : any = "All"

    constructor(private pendingFeesReportService: PendingFeesReportService, private categoryServices: CategoryService, private translate: TranslateService) { }

    ngOnInit(): void {
        this.getAcademicYear();
        this.getGenderListData();
        this.string = stringsData;
        const schoolDetails = localStorage.getItem('schoolAllInfo')
        const data = JSON.parse(schoolDetails);
        this.schoolCurrencySymbol = data.schoolCurrencySymbol;
        this.setTranslatedDefaults();
        this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.setTranslatedDefaults();
        });
    }

     setTranslatedDefaults(): void {
        this.translate.get([
            'all',
        ]).subscribe(translations => {
            this.appliedWing = translations['all'];
            this.appliedClass = translations['all'];
            this.appliedSection = translations['all'];
            this.appliedGender = translations['all'];
        });
        
    }

    // function to focus on search input box
    onFocusSearchInput() {
        this.isFocused = true;
        this.isOpenStudentSelection = true;
        this.studentList = [...this.completeStudentList];
    }

    // function to blur on search input box
    onBlurSearchInput() {
        this.isFocused = false;
    }

    // function trigger when user enter the text in the search box
    onSearchChange(val) {
        this.isOpenStudentSelection = true;
        const value = val.toLowerCase();
        if (value) {
            this.studentList = this.completeStudentList.filter(user =>
                user.studentName.toLowerCase().includes(value)
            );
        }
    }

    // Click outside close the dropdown list
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        this.isOpenStudentSelection = false;
    }

    // function on select the academic years in the dropdown  
    onSelectionChange(): void {
        this.resetAllFilter();
        this.getPendingFeesStats();
        this.applyAllWing();
        this.tileDataOrTableData();
    }

    // function for select student in filter option
    markStudent(index: number, event: Event) {
        const filteredStudent = this.studentList[index];
        filteredStudent.isChecked = !filteredStudent.isChecked;
        this.updateSelectedStudentCount();
        this.checkAllMarked();
    }

    // Mark all students
    markAllStudent(value) {
        const isChecked = value.checked;
        this.completeStudentList.forEach((student) => {
            student.isChecked = isChecked;
        });

        this.studentList.forEach((student) => {
            student.isChecked = isChecked;
        });

        this.updateSelectedStudentCount();
        this.allStudentSelected = isChecked;
    }

    // Check if all students are marked
    checkAllMarked() {
        this.allStudentSelected = this.completeStudentList.every(
            (student) => student.isChecked
        );
    }

    // function to update the student count
    updateSelectedStudentCount() {
        this.selectedStudentListLength = this.completeStudentList.filter(
            (student) => student.isChecked
        ).length;
    }

    // function for generate student string through array
    getStudentListForAttendance() {
        const data = this.completeStudentList.filter(
            (student) => student.isChecked === true
        );
        if (data.length === this.completeStudentList.length) return "All";
        if (data.length > 0) {
            const studentIdString = data
                .map((student) => student.studentId)
                .join(",");
            return studentIdString;
        } else {
            return "All";
        }
    }

    // function for expand all filters
    expandAllFilterItems() {
        this.isFilterExpanded = !this.isFilterExpanded;
    }


    // function for close student selection option
    closeStudentSelection() {
        this.isOpenStudentSelection = false;
    }

    // function for close student dropdown from table header
    openTableHeadersOption(index) {
        if (index === this.optionHeaderIndex) {
            this.optionHeaderIndex = "";
        } else {
            this.optionHeaderIndex = index;
        }
    }

    // function for close table header option
    closeCollapseOptionTable() {
        this.optionHeaderIndex = "";
    }

    // function to get the academic years 
    async getAcademicYear() {
        try {
            const response: any = await firstValueFrom(
                this.pendingFeesReportService.getAcademicYears()
            );
            if (response?.status) {
                if (response?.body?.academicListData) {
                    this.academicYears = response?.body?.academicListData;
                }
                const currentAcademic = this.academicYears.find(
                    (year) => year.isCurrentAcademic
                );
                if (currentAcademic) {
                    this.selectedYearId = currentAcademic.pkAcademicId;
                }
                this.getPendingFeesStats();
                this.getClassData();
                this.tileDataOrTableData();
            }
        }
        catch (error) {
            const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }

    // api for get class data in filter section   
    async getClassData() {
        try {
            this.classStandardData = [];
            this.selectedClass = null;
            this.selectedSection = null;
            this.allStudentSelected = false;
            this.classSectionData = [];
            this.studentList = [];
            this.completeStudentList = [];
            this.loadingWingData = true;
            const response: any = await firstValueFrom(
                this.categoryServices.getWingData()
            );
            if (response.status && response.body) {
                this.wingListData = response.body.classCategoryListDetails
                    ? response.body.classCategoryListDetails
                    : [];
            } else {
                this.wingListData = [];
            }
            this.loadingWingData = false;
        }
        catch (error) {
            this.loadingWingData = false;
            this.wingListData = [];
             const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }

    // function to get the class category data
    async getClassCategoryData(selectedWing) {
        try {
            this.loadingClassData = true;
            this.classStandardData = [];
            this.selectedClass = null;
            this.selectedSection = null;
            this.classSectionData = [];
            this.studentList = [];
            this.allStudentSelected = false;
            this.completeStudentList = [];
            this.selectedStudentListLength = '';
            const wingId = selectedWing.categoryId;
            const response: any = await firstValueFrom(
                this.categoryServices.getClassStandardList(wingId)
            );
            if (response.status && response.body) {
                this.classStandardData = response.body
                    .classCategoryListData
                    ? response.body.classCategoryListData
                    : [];
            }
            else {
                this.classStandardData = [];
            }
            this.loadingClassData = false;
        }
        catch (error) {
            this.loadingClassData = false;
            this.classStandardData = [];
             const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }

    // api for get class section data
    async getClassSectionData(selectedClass) {
        try {
            this.selectedSection = null;
            this.classSectionData = [];
            this.studentList = [];
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.selectedStudentListLength = ''; 
            this.loadingSectionData = true;
            const wingId = this.selectedWing.categoryId;
            const classId = selectedClass.pkClassStandardsId;
            const response: any = await firstValueFrom(
                this.categoryServices.getClassSectionData(wingId, classId)
            );
            if (response.status && response.body) {
                this.classSectionData = response.body.classSectionListData
                    ? response.body.classSectionListData
                    : [];
            } else {
                this.classSectionData = [];
            }
            this.loadingSectionData = false;
        }
        catch (error) {
            this.loadingSectionData = false;
            this.classSectionData = [];
            if (error?.message) {
                customToastr(error?.message, this.string.errorCode);
            }
            else {
                 const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
                customToastr(defaultErrorMessageTranslations, this.string.errorCode);
            }
        }
    }

    // api for get gender list data
    async getGenderListData() {
        try {
            const response: any = await firstValueFrom(
                this.categoryServices.getGenderList()
            );
            if (response.status && response.body) {
                this.genderData = response.body.studentGenderListDetails
                    ? response.body.studentGenderListDetails
                    : [];
            } else {
                this.genderData = [];
            }
        } catch (error) {
            this.genderData = [];
             const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }

    // function to get student list data in filter section
    async getStudentData(sectionId) {
        try {
            this.studentList = [];
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.selectedStudentListLength = '';
            this.loadingStudentDropdownData = true;
            const wingId = this.selectedWing.categoryId;
            const classCategoryId = this.selectedClass.pkClassStandardsId || this.selectedClass.classStandardId;
            const section = sectionId.classId;
            const gender = this.selectedGender?.studentGender
                ? this.selectedGender?.studentGender
                : "All";
            this.selectAllChecked = false;
            const response: any = await firstValueFrom(
                this.pendingFeesReportService.getStudentListData(
                    wingId,
                    classCategoryId,
                    section,
                    gender,
                    this.selectedYearId
                )
            );
            if (response.status && response.body) {
                this.completeStudentList = response.body.studentListForFees
                    ? response.body.studentListForFees
                    : [];
            }
            this.loadingStudentDropdownData = false;
            this.studentList = [...this.completeStudentList];
        }
        catch (error) {
            this.loadingStudentDropdownData = false;
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.selectedStudentListLength = '';
             const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }

    // function for apply "All" filter in filter
    applyAllWing() {
        this.classStandardData = [];
        this.selectedClass = null;
        this.selectedSection = null;
        this.classSectionData = [];
        this.studentList = [];
        this.completeStudentList = [];
        this.allStudentSelected = false;
        this.selectedStudentListLength = '';
    }

    // function for apply "All" class  in filter
    applyAllClass() {
        this.selectedSection = null;
        this.classSectionData = [];
        this.studentList = [];
        this.completeStudentList = [];
        this.allStudentSelected = false;
        this.selectedStudentListLength = '';
    }

    // function for apply "All" section  in filter
    applyAllSection() {
        this.allStudentSelected = false;
        this.selectedStudentListLength = "";
        this.studentList = [];
        this.completeStudentList = [];
    }

    // function for fetch student list in filter
    callClassStudentListData() {
        if (this.selectedSection != null) {
            this.studentList = [];
            this.completeStudentList = [];
            this.allStudentSelected = false;
            this.selectedStudentListLength = '';
            this.getStudentData(this.selectedSection);
        }
    }

    // function for apply all gender
    applyAllGender() {
        this.callClassStudentListData();
    }

    //  function for get stats for student attendance
    async getPendingFeesStats() {
        try {
            this.loadingStatData = true;
            const payload = {
                classCategoryId: this.appliedWings,
                classStandardId: this.appliedClassStandard,
                classId: this.appliedClassId,
                gender: this.appliedGenders,
                studentList: this.selectedStudent,
                selectedAcademicYearId: this.selectedYearId
            };
            const response: any = await firstValueFrom(
                this.pendingFeesReportService.getStatData(payload)
            );
            if (response.status && response.body) {
                this.studentStatData = response.body.feesCount
                    ? response.body.feesCount
                    : [];
                this.resultAvailable = response.body.resultAvailable
                    ? response.body.resultAvailable
                    : "0";
            }
            this.loadingStatData = false;
        }
        catch (error) {
            this.loadingStatData = false;
             const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }
    // function for apply filter
    applyFilter() {
        const all = "All";
        this.appliedWings =   this.selectedWing != null ? this.selectedWing?.categoryId : all ;
        this.appliedClassId = this.selectedSection != null ? this.selectedSection?.classId : all;
        this.appliedClassStandard = this.selectedClass!= null ? this.selectedClass?.pkClassStandardsId: all;
        this.appliedGenders = this.selectedGender != null ? this.selectedGender.studentGender : all
        this.filterSelectedStudent = this.getStudentListForAttendance();
        this.selectedStudent =   this.getStudentListForAttendance();

        this.appliedWing = this.selectedWing
            ? this.selectedWing.categoryName || this.selectedWing.classCategoryName 
            : "All";
        this.appliedClass = this.selectedClass
            ? this.selectedClass.classStandardName
            : "All";
        this.appliedSection = this.selectedSection
            ? this.selectedSection.classDivision
            : "All";
        this.appliedGender = this.selectedGender
            ? this.selectedGender.studentGender
            : "All";
        this.appliedStudent =
            this.selectedStudentListLength > 0 ? this.selectedStudentListLength : "";
        this.startingPageNumber = 1;
        this.getPendingFeesStats();
        this.tileDataOrTableData();
        this.enableReset = true;
        this.filterWingId=this.selectedWing
        ? this.selectedWing.categoryId
        : "All";
        this.filterClassId= this.selectedClass
        ? this.selectedClass.classStandardId || this.selectedClass.pkClassStandardsId  
        : "All";
        this.filterSectionId=
        this.selectedSection
            ? this.selectedSection.classId
            : "All";
        this.filterGender= this.selectedGender
        ? this.selectedGender.studentGender
        : "All";
    
        if (this.selectedStudentListLength === this.completeStudentList.length){
            this.isSelectedStudentCountDisplay = false;
        }
        else{
            this.isSelectedStudentCountDisplay = true;
        }
    }

    // function for get class tile data
    async getAllClassData(pageNumber) {
        try {
            this.loadingClassTileData = true;
            const payload = {
                classCategoryId: this.appliedWings,
                classStandardId: this.appliedClassStandard,
                classId : this.appliedClassId,
                gender: this.appliedGenders,
                limit: 12,
                pageNumber: pageNumber,
                selectedAcademicYearId: this.selectedYearId
            };
            const response: any = await firstValueFrom(
                this.pendingFeesReportService.getAllClassData(payload)
            );
            if (response.status && response.body) {
                this.pendingFeeData = response.body.reportClassData
                    ? response.body.reportClassData
                    : [];
                this.generatePageNumber(response.body.maxPageNumber);
            }
            this.loadingClassTileData = false;
        }
        catch (error) {
            this.loadingClassTileData = false;
             const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }

    // function for generate page number
    generatePageNumber(maxPage) {
        this.maxPageNumber = maxPage;
        let displayedPages = [];
        let currentPage = this.startingPageNumber;

        if (maxPage < 4) {
            displayedPages = Array.from({ length: maxPage }, (_, i) => i + 1);
        } else {
            if (currentPage === 1) {
                displayedPages.push(
                    ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
                );
            } else if (currentPage === maxPage) {
                displayedPages.push(
                    ...Array.from(
                        { length: Math.min(5, maxPage) },
                        (_, i) => maxPage - 4 + i
                    )
                );
            } else if (currentPage >= 4 && currentPage <= maxPage - 3) {
                displayedPages.push(
                    ...Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
                );
            } else if (currentPage < 4) {
                displayedPages.push(
                    ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
                );
            } else if (currentPage > maxPage - 4) {
                displayedPages.push(
                    ...Array.from(
                        { length: Math.min(5, maxPage) },
                        (_, i) => maxPage - 4 + i
                    )
                );
            }

            displayedPages = displayedPages
                .filter((page) => page > 0 && page <= maxPage)
                .sort((a, b) => a - b);

            if (!displayedPages.includes(maxPage)) {
                displayedPages.push("...");
                displayedPages.push(maxPage);
            }
        }
        this.pageNumbers = displayedPages;
    }

    // function for jump page number on click of page number
    switchPageNumber(pageNumber) {
        this.startingPageNumber = pageNumber;
        this.tileDataOrTableData();
    }

    // function for page switch
    changePageLimitData(pageNumber) {
        this.startingPageNumber = pageNumber;
        this.pageLimit = pageNumber;
        this.tileDataOrTableData();
    }

    // function for get specific class wise data
    async getClassWiseData(limit) {
        try {
            this.loadingClassTableData = true;
            const payload = {
                classCategoryId:this.appliedWings,
                classStandardId: this.appliedClassStandard,
                classId: this.appliedClassId,
                gender: this.appliedGenders,
                pageNumber: this.startingPageNumber,
                studentList: this.selectedStudent,
                pageLimit: limit,
                selectedAcademicYearId: this.selectedYearId
            };
            const response: any = await firstValueFrom(
                this.pendingFeesReportService.getPendingFeeClassWiseData(payload)
            );
            if (response.status && response.body) {
                if (this.tableHeaderData.length === 0) {
                    this.tableHeaderData = response.body.reportColumnList
                        ? response.body.reportColumnList
                        : [];
                }
                this.generatePageNumber(response.body.maxPageNumber);
                this.tableBodyData = response.body.reportStudentData
                    ? response.body.reportStudentData
                    : [];
                this.loadingClassTableData = false;
            }
        } catch (error) {
            this.loadingClassTableData = false;
             const defaultErrorMessageTranslations = await firstValueFrom(this.translate.get('defaultErrorMessage'));
            customToastr(
                error.error.message
                    ? error.error.message
                    : defaultErrorMessageTranslations,
                this.string.errorCode
            );
        }
    }

    // function for decide which data need to be visible
    tileDataOrTableData() {
        if (this.appliedClassId=="All") {
            this.getAllClassData(this.startingPageNumber);
            this.tableHeaderData = [];
            this.tableBodyData = [];
        } else {
            this.pendingFeeData = [];
            this.getClassWiseData(this.pageLimitForClassWiseDate);
        }
    }

    // function for update table header
    async updateTableColumn(currentSlug, newSlug) {
        const currentSlugDataIndex = this.tableHeaderData.findIndex((item) => {
            const data = item as any;
            return data.slug === currentSlug;
        });
        const newSlugDataIndex = this.tableHeaderData.findIndex((item) => {
            const data = item as any;
            return data.slug === newSlug;
        });
        if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
            const slugCurrentData = this.tableHeaderData[currentSlugDataIndex];
            const slugNewData = this.tableHeaderData[newSlugDataIndex];
            const currentInfo = slugCurrentData as any;
            const newInfo = slugNewData as any;
            currentInfo.isDefault = 0;
            newInfo.isDefault = 1;
            if (this.tableHeaderData.length > 0) {
                this.tableHeaderData[currentSlugDataIndex] = newInfo;
                this.tableHeaderData[newSlugDataIndex] = currentInfo;
            }
        }
    }

    // function for change page limit for class table data
    changePageLimit(limit) {
        this.startingPageNumber = 1;
        this.pageLimitForClassWiseDate = limit;
        this.getClassWiseData(limit);
    }

    // function for reset filter
    resetAllFilter() {
        this.filterWingId='All';
        this.filterClassId='All';
        this.filterSectionId='All';
        this.filterGender= 'All';
        this.filterSelectedStudent='All';
        this.selectedClass = null;
        this.selectedWing = null;
        this.selectedSection = null;
        this.selectedGender = null;
        this.classSectionData = [];
        this.classStandardData = [];
        this.studentList = [];
        this.completeStudentList = [];
        this.selectedStudentListLength = "";
        this.allStudentSelected = false;
        this.applyFilter();
        this.enableReset = false;
        this.enableBackButton = false;
    }

    // function for open class info using selected tile
    fetchSelectedClassData(data) {
        this.selectedClassFilter(data);
    }

    // function for apply filter according to class selection from tile
    selectedClassFilter(data) {
        this.selectedWing = null;
        this.selectedClass = null;
        this.selectedSection = null;
        this.selectedWing = {
            categoryId: data.categoryId,
            categoryName: data.categoryName,
        };
        this.selectedSection = {
            classId: data.classId,
            classDivision: data.classDivision,
        };
        this.selectedClass = {
            pkClassStandardsId: data.classStandardId,
            classStandardName: data.classStandard,
        };
      

        this.startingPageNumber = 1;
        this.enableBackButton = true;
        this.getStudentData(this.selectedSection);
        const all ="All"
        this.appliedWings =   data.categoryId ;
        this.appliedClassId =  data.classId;
        this.appliedClassStandard =  data.classStandardId;
        this.getPendingFeesStats();
        this.tileDataOrTableData();
        this.appliedWing = this.selectedWing
            ? this.selectedWing.categoryName ||  this.selectedWing.classCategoryName 
            : "All";
        this.appliedClass = this.selectedClass
            ? this.selectedClass.classStandardName
            : "All";
        this.appliedSection = this.selectedSection
            ? this.selectedSection.classDivision
            : "All";
        this.filterWingId=this.selectedWing
            ? this.selectedWing.categoryId
            : "All";
        this.filterClassId= this.selectedClass
            ? this.selectedClass.classStandardId || this.selectedClass.pkClassStandardsId 
            : "All";
        this.filterSectionId=
            this.selectedSection
                ? this.selectedSection.classId
                : "All";
        this.filterGender= this.selectedGender
            ? this.selectedGender.studentGender
            : "All";
        this.filterSelectedStudent = this.getStudentListForAttendance(); 
    }

    // function for export pending fees report and download it directly
    async exportReport() {
        try {
            this.isExportingReport = true;
            const tableColumnArray = [];
            for (let j = 0; j < this.tableHeaderData.length; j++) {
                const tableData: any = this.tableHeaderData[j];
                if (tableData.isDefault == 1) {
                    tableColumnArray.push(tableData.pkReportColumnMapDetailId);
                }
            }
            const body = {
                lang: 'en',
                academicId: this.selectedYearId,
                exportType: this.string.reportFormat,
                selectedColumns: tableColumnArray.length == 0 ? "" : tableColumnArray,
                emailIdList: [],
                classCategoryId: this.filterWingId,
                classStandardId:  this.filterClassId,
                classId: this.filterSectionId,
                gender: this.filterGender,
                studentIdList: this.filterSelectedStudent
            };
            const response: any = await firstValueFrom(
                this.pendingFeesReportService.exportReportData(body)
            );
            if (response instanceof Blob) {
                const url = window.URL.createObjectURL(response);
                const a = document.createElement("a");
                a.href = url;
                a.download = "PendingFeesReport.xlsx";
                a.click();
                window.URL.revokeObjectURL(url);
            }
            const successMsg = await firstValueFrom(this.translate.get('reportExportedSuccessfully'));
            customToastr(successMsg, this.string.successCode);
        }
        catch (error) {
             const errorExportTranslations = await firstValueFrom(this.translate.get('errorExport'));
            customToastr(
                error.error && error.error.message
                    ? error.error.message
                    : errorExportTranslations,
                this.string.errorCode
            );
        }
        finally {
            this.isExportingReport = false;
        }
    }

    //function for  format number  
     formatNumber(num) {
        if (typeof num !== 'number' || isNaN(num)) {
            return num;  
        }
        return num.toLocaleString('en-IN');
    }
    
        
    // generate number to words
    generateText(num){
       return this.toWords.convert(num, { currency: true, ignoreDecimal: true });
    }
}